import axios from "axios";
import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IDeviceFilter } from "../models/filters/deviceFilter";
import IDeviceForm from "../models/forms/deviceForm";
import IDevicePDTO from "../models/dtos/devicePDTO";

/** Logique d'interaction avec les matériels */
export default class DeviceServices extends _o2sService {

    protected static override mainUrl: string = API_CENTRE + "/api/v1/devices";

    protected static override getUrlFilter<F extends IDeviceFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != undefined) 
        {
            if ( filter.typeId != undefined)
                url += `&TypeId=${filter.typeId}`;
            if ( filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
        }
        return url;
    }

    protected static override toDTO(obj: IDeviceForm): IDevicePDTO {
        const dto = super.toDTO(obj) as IDevicePDTO;
        
        return dto;
    }

    public static sendBeacon(url: string): void {
        navigator.sendBeacon(`${this.mainUrl}/${url}`);
    }
}
